module.exports = __webpack_public_path__ + "static/media/21.76a2f6f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/21.jpg
// module id = 554
// module chunks = 0